<script>

import TrainingForm from "@/components/trainings/form/TrainingForm.vue";
import { getPreferredLocale } from "@/utils/locale.js";

export default {
    components: {TrainingForm},
    data() {
        return {
            training: {
                name: '',
                price: '',
                description: '',
                images: [],
                tags: [],
                dates: [],
                is_active: 1,
                is_available_individually: 1,
                language: getPreferredLocale()
            }
        }
    }
}

</script>
<template>
    <div class="trainings-create">
        <TrainingForm :training="training"/>
    </div>
</template>
